import { cn } from '@exam-room/utils';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import * as Form from '../base/form';
import MathRenderer from '../math-renderer';

export enum QuestionType {
  CHOICES = 'choices',
  MATH = 'math',
}

interface QuestionProps {
  name: string;
  number: number;
  title: string;
  choices?: JSX.Element;
  actions?: JSX.Element[];
  className?: string;
  solution?: React.ReactNode;
  paragraphs?: string;
  tag: string;
}

export default function Question(props: QuestionProps) {
  const { t } = useTranslation();
  const { name, number, title, choices, actions, solution, className, tag, paragraphs } = props;

  const question = <MathRenderer content={title} className={cn('mt-1 w-full flex-1', className)} />;

  return (
    <div className='w-full space-y-4'>
      <div data-exam-content data-renderer className='text-body1 mb-2'>
        {tag}
      </div>
      <div className='flex w-full justify-between select-none'>
        <div className='flex w-full items-center gap-3'>
          <div className='bg-primary h-full w-1' />
          <h5>{t('question.item', { number })}</h5>
        </div>
        <div className='ml-auto flex shrink-0 flex-col items-center gap-3 md:flex-row md:gap-4'>
          {actions}
        </div>
      </div>
      <div data-exam-content data-renderer className='flex flex-col gap-4'>
        {paragraphs ? (
          <div className='bg-grey-100 flex items-start gap-4 rounded-md p-4'>
            <MathRenderer content={paragraphs} className='w-full flex-1' />
          </div>
        ) : null}
        <div className='bg-grey-100 flex items-start gap-4 rounded-md p-4'>{question}</div>
        {!solution ? (
          <div className='mt-6'>
            <Form.Input type='radio' name={name} radios={choices} />
          </div>
        ) : (
          <div className='mt-6'>
            {choices}
            {solution}
          </div>
        )}
      </div>
    </div>
  );
}
